import React from "react";

export default function AuditLogModal({ user, auditLog, onClose }) {
  return (
    <div className="modal-backdrop">
      <div className="modal-content" style={{ maxWidth: 420, padding: 22 }}>
        <h3>Audit Log for {user.email}</h3>
        <div style={{ maxHeight: 270, overflowY: "auto", margin: "13px 0" }}>
          {auditLog.length === 0 ? (
            <div style={{ color: "#888", fontSize: 15 }}>No recent actions logged.</div>
          ) : (
            <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
              {auditLog.map((entry, i) => (
                <li key={i} style={{ marginBottom: 9, fontSize: 14 }}>
                  <b>{new Date(entry.timestamp).toLocaleString()}:</b>
                  &nbsp;{entry.action}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="modal-actions">
          <button className="btn" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
